import { Typography } from "@mui/material";
import { Error as ErrorIcon } from "@mui/icons-material";
import styled, { css } from "styled-components/macro";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${css`
    ${({ theme }) => theme.spacing(2)}
  `};
`;

const StyledErrorIcon = styled(ErrorIcon)`
  font-size: ${css`
    ${({ theme }) => theme.spacing(7)}
  `} !important;
`;

export const TestId = "Components/Generic/Error";

interface GenericErrorProps {
  title: string;
  message: string;
}

export function GenericError({ title, message }: GenericErrorProps) {
  return (
    <Container>
      <StyledErrorIcon />
      <Typography variant="h5">{title}</Typography>
      <Typography>{message}</Typography>
    </Container>
  );
}
